angular.module('properties.sources')
    .filter('availablePoints', function() {
        return function(points) {

            return _.filter(points, function(point) {
                return point.assignable && point.inputs.length == 0;
            });
        }
    });
